import React from 'react';
import styles from './TaskPartnerItem.module.scss';
import { version } from '../../../../package.json';
const TaskPartnerItem: React.FC = () => {
  return (
    <>
      {/* <div className={styles.taskPartnerItem}>
        <a
          href="https://t.me/vlad_m20" // замени на ссылку своего канала
          target="_blank"
          rel="noopener noreferrer"
          className={styles.taskPartnerItem__link}
        >
          Стать нашим партнёром
        </a>
      </div> */}
      <div className={styles.versionInfo}>
        <span className={styles.versionText}>v{__APP_VERSION__}</span>
      </div>
    </>
  );
};

export default TaskPartnerItem;
